import { render, staticRenderFns } from "./scientific-analysis-import-modal.vue?vue&type=template&id=35b54468&scoped=true&"
import script from "./scientific-analysis-import-modal.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-import-modal.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-import-modal.scss?vue&type=style&index=0&id=35b54468&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b54468",
  null
  
)

export default component.exports